/**
 * @generated SignedSource<<f0c7765365edc8073efeecbd7f0902b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateDigestWizard_organization$data = {
  readonly id: any;
  readonly " $fragmentType": "CreateDigestWizard_organization";
};
export type CreateDigestWizard_organization$key = {
  readonly " $data"?: CreateDigestWizard_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateDigestWizard_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateDigestWizard_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganization",
  "abstractKey": null
};

(node as any).hash = "bb6a640d748242180d77c014b3fc2e48";

export default node;
